module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Неизвестный способ платежа.":"Unknown payment method."}}')
  delete Component.options._Ctor
}
